import { Web } from '@mui/icons-material';
import { Components, Theme } from '@mui/material/styles';

export default function MuiOutlinedInput(theme: Theme): Components['MuiOutlinedInput'] {
  return {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.sandTint.main,
        border: `1px solid ${theme.palette.sandShade3.main}`,
        borderRadius: '4px',
        paddingLeft: '12px',
        '&.Mui-focused': {
          borderColor: theme.palette.ocean.main,
        },
        '&.Mui-error': {
          borderColor: theme.palette.error.main,
        },
        '&:has(input:autofill)': {
          backgroundColor: theme.palette.autoFill.main,
        },
        '&.Mui-disabled': {
          backgroundColor: `${theme.palette.sandTint.main}80`,
          borderColor: `${theme.palette.sandShade3.main}80`,
        },
      },
      input: {
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingRight: '12px',
        paddingLeft: 0,
        '::placeholder': {
          color: theme.palette.taigaTint2.main,
          opacity: 1,
        },
        ':autofill': {
          boxShadow: `0 0 0 1000px ${theme.palette.autoFill.main} inset !important`,
        },
        '&.Mui-disabled': {
          WebkitTextFillColor: 'revert',
          color: theme.palette.taigaTint1.main,
        },
      },
      notchedOutline: {
        display: 'none',
      },
      multiline: {
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
      },
    },
  };
}
